import React from 'react';

function Mobile() {
  return <div>PersonCards</div>;
}

export default Mobile;
